<template>
  <div class="capabilities-area pt-100 pb-75">
    <div class="container">
      <div class="section-title text-center mb-5">
        <span class="top-title">CAPABILITIES</span>
        <h2>
          Drive traffic, generate leads, achieve success with our paid search
          services!
        </h2>
      </div>

      <div class="row justify-content-center gy-4">
        <div
          class="col-12 col-sm-6 col-md-4 d-flex"
          v-for="capabilitie in capabilities"
          :key="capabilitie.id"
          data-aos="fade-up"
          data-aos-duration="1200"
          :data-aos-delay="capabilitie.dataDelay"
        >
          <div class="capabilities-single-item w-100 d-flex flex-column h-100">
            <div class="icon">
              <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore"  :src="capabilitie.imageIcon" :alt="capabilitie.title" />
            </div>
            <h3>{{ capabilitie.title }}</h3>
            <p class="flex-grow-1">{{ capabilitie.description }}</p>
            <router-link :to="capabilitie.link" class="read-more mt-auto">
              READ MORE
              <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
                src="../../assets/images/icon-right-red.png"
                alt="icon-right-red"
              />
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CapabilitiesContent",
  data() {
    return {
      capabilities: [
        {
          id: 1,
          dataDelay: "200",
          imageIcon: require("../../assets/images/guest-star.png"),
          title: "Influencer Marketing & Celebrity Promotions",
          description:
            "Connect your brand with the right faces — from regional stars to Bollywood icons and social media influencers across India. From storytelling to strategy, we ensure visibility, relatability, and results.",
          link: "/service-details-1"
        },
        {
          id: 2,
          dataDelay: "300",
          imageIcon: require("../../assets/images/camera.png"),
          title: "Ad Shoots & TV Commercials (TVCs)",
          description:
            "We produce compelling visuals from concept to camera. Our team handles everything: scripting, casting, shooting, post-production, and publishing across media.",
          link: "/service-details-2"
        },
        {
          id: 3,
          dataDelay: "400",
          imageIcon: require("../../assets/images/content.png"),
          title: "Digital Marketing Services",
          description:
            "SEO, Google Ads, Meta campaigns, content strategy, and more — we help brands scale online with data-backed growth tactics.",
          link: "/service-details-3"
        },
        {
          id: 4,
          dataDelay: "500",
          imageIcon: require("../../assets/images/inaugurations.png"),
          title: "Events & Inauguration",
          description:
            "Need to launch a product, open a store, or elevate your next big event? We manage everything end-to-end from celebrity guests to press coverage.",
          link: "/service-details-4"
        },
        {
          id: 5,
          dataDelay: "600",
          imageIcon: require("../../assets/images/bluebadge.png"),
          title: "Verified Badge Services (Instagram & Facebook)",
          description:
            "We help eligible public figures, influencers, and brands secure the verified blue tick, increasing credibility and brand trust.",
          link: "/service-details-5"
        },
        {
          id: 6,
          dataDelay: "700",
             imageIcon: require("../../assets/images/conference.png"),
          title: "PR Article & Media Coverage Services",
          description:
            "We help brands build credibility, visibility, and trust through powerful PR article placements in top-tier media outlets.",
        
          link: "/service-details-6"
        }
      ],
    };
  },
});
</script>

<style scoped>
.capabilities-area {
  background: linear-gradient(
    180deg,
    #fff 0%,
    rgba(255, 150, 150, 0.27) 0%,
    rgba(255, 150, 150, 0.27) 42.19%,
    rgba(255, 255, 255, 0) 100%
  );
}

.capabilities-single-item {
  background-color: var(--whiteColor);
  border-radius: 20px;
  padding: 48px 38px;
  transition: var(--transition);
  display: flex;
  flex-direction: column;
  height: 100%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04);
}

.capabilities-single-item .icon {
  width: 70px;
  height: 70px;
  line-height: 70px;
  background-color: #f2f2f8;
  text-align: center;
  border-radius: 50px;
  margin-bottom: 15px;
}

.capabilities-single-item .icon img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.capabilities-single-item h3 {
  font-size: 22px;
  margin-bottom: 15px;
}

.capabilities-single-item p {
  margin-bottom: 20px;
  flex-grow: 1;
}

.capabilities-single-item .read-more {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 14px;
  color: #e63946;
}

.section-title .top-title {
  font-weight: 700;
  color: #e63946;
  font-size: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
  display: block;
  margin-bottom: 10px;
}

.section-title h2 {
  font-size: 28px;
  font-weight: 700;
  color: #222;
}

/* Responsive */
@media (max-width: 767px) {
  .capabilities-single-item {
    padding: 20px;
  }
  .capabilities-single-item h3 {
    font-size: 20px;
  }
  .section-title h2 {
    font-size: 24px;
  }
}

@media (min-width: 1200px) and (max-width: 1399px) {
  .capabilities-single-item {
    padding: 30px;
  }
}
</style>
